export default {
  toasts: {
    load_error: 'Palkkioiden lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  rates: {
    title: 'Käsittelymarginaali',
    description:
      'Prosentti %-muodossa sekä valinnainen kiinteä ja vähimmäismäärä veloitusta kohden. ”Mikä tahansa maksutapa” on voimassa, kun maksutapakohtaista hintaa ei ole.',
    default: {
      inherits:
        'Adyen-hintaa ei ole asetettu, joten tämän kumppanin ravintolat, jotka käyttävät FoodAmigosin Adyenia, maksavat alla olevan FoodAmigosin oletushinnan. Tässä asettamasi hinta korvaa sen; yksittäiselle ravintolalle asetettu hinta on edelleen ensisijainen.',
      overridden:
        'Tämän kumppanin oma Adyen-hinta korvaa alla olevan FoodAmigosin oletushinnan sen ravintoloille, jotka käyttävät FoodAmigosin Adyenia. Poista se, jos haluat palata oletushintaan.',
      own_adyen:
        'Tämä kumppani käsittelee maksut omalla Adyen-tilillään. Sen ravintoloiden ei tarvitse maksaa käsittelymaksua, ellei tässä tai yksittäisellä ravintolalla ole asetettu prosenttia.',
      master:
        'Nämä ovat FoodAmigosin oletushinnat. Niitä käyttää jokainen kumppani, joka käyttää FoodAmigosin Adyenia ilman omaa Adyen-hintaa.',
      rows_title: 'FoodAmigosin oletushinnat',
    },
  },
};
